<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-y-16">
    <Teleport
      defer
      to="#portal-modal-header-target"
    >
      {{ content.Referral.title }}
    </Teleport>

    <img
      v-if="content.Referral.metadata.imageUrl"
      class="cf-image cf-image--logo"
      :alt="merchant.name"
      :src="content.Referral.metadata.imageUrl"
      onerror="this.src='/images/image-not-found.png';"
    >

    <p class="cf-subtitle cf-subtitle--2">
      {{ content.Referral.metadata.subtitle }}
    </p>

    <cf-copy-to-clipboard
      name="friendReferralUrl"
      label="Referral Link"
      :value="loyalty.referralLink"
    />
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfCopyToClipboard from '@/view/components/shared/cf-copy-to-clipboard/index.vue';

  export default {
    name: 'ReferAFriend',

    components: {
      CfCopyToClipboard
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('offers', ['loyalty']),
      ...mapGetters('merchant', ['merchant'])
    }
  };
</script>
